import { ConfigParams } from '../config-types';

export const ContentUrlConfig: Array<ConfigParams> = [
  {
    Page: '合作伙伴页',
    PCURL: '/cooperative',
    WapURL: '/mobile/cooperative',
  },
  {
    Page: '新闻资讯列表页',
    PCURL: '/information',
    WapURL: '/mobile/market',
    WapURLParams: [
      {
        ParamsName: 'active',
        ParamsType: 'query',
        FixedValue: 'C008',
        MatchedUrlFn: (params) => {
          return params.active == 'C008';
        },
      },
    ],
  },
  {
    Page: '新闻资讯详情页',
    PCURL: '/information/details',
    PCDynamicUrl: '/information/details/[id]',
    PCURLParams: [
      {
        ParamsName: 'id',
        ParamsType: 'params',
      },
    ],
    WapURL: '/mobile/market/details',
    WapURLParams: [
      {
        ParamsName: 'id',
        ParamsType: 'query',
      },
      {
        ParamsName: 'type',
        ParamsType: 'query',
        FixedValue: 'market',
        MatchedUrlFn: (params) => {
          return params.type == 'market';
        },
      },
    ],
  },
  {
    Page: '优秀合作案例列表页',
    PCURL: '/goodcase',
    PCURLParams: [
      {
        ParamsName: 'timeSort',
        ParamsType: 'query',
      },
    ],
    WapURL: '/mobile/goodcase',
    WapURLParams: [
      {
        ParamsName: 'timeSort',
        ParamsType: 'query',
      },
    ],
  },
  {
    Page: '优秀合作案例详情页',
    PCURL: '/goodcase/details',
    PCDynamicUrl: '/goodcase/details/[id]',
    PCURLParams: [
      {
        ParamsName: 'id',
        ParamsType: 'params',
      },
    ],
    WapURL: '/mobile/goodcase/details',
    WapURLParams: [
      {
        ParamsName: 'id',
        ParamsType: 'query',
      },
    ],
  },
  {
    Page: '政策公告列表页',
    PCURL: '/policy',
    WapURL: '/mobile/policy',
  },
  {
    Page: '政策公告详情页',
    PCURL: '/policy/details',
    PCDynamicUrl: '/policy/details/[id]',
    PCURLParams: [
      {
        ParamsName: 'id',
        ParamsType: 'params',
      },
    ],
    WapURL: '/mobile/market/details',
    WapURLParams: [
      {
        ParamsName: 'id',
        ParamsType: 'query',
      },
      {
        ParamsName: 'type',
        ParamsType: 'query',
        FixedValue: 'policy',
        MatchedUrlFn: (params) => {
          return params.type == 'policy';
        },
      },
    ],
  },
];
